import React, { useMemo, useCallback } from 'react';
import Select from 'react-select';

const locations = [
    'AB', 'AK', 'AL', 'AR', 'AZ',
    'BC', 'Baja California', 'Baja Sur',
    'CA', 'CO', 'CT',
    'DC', 'DE',
    'FL',
    'GA',
    'HI',
    'IA', 'ID', 'IL', 'IN',
    'KS', 'KY',
    'LA',
    'MA', 'MB', 'MD', 'ME', 'MI', 'MN', 'MO', 'MT',
    'NB', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NS', 'NT', 'NU', 'NV', 'NY',
    'OH', 'OK', 'ON', 'OR',
    'PA', 'PE',
    'QC',
    'RI',
    'SC', 'SD', 'SK',
    'TN', 'TX',
    'UT',
    'VA', 'VT',
    'WA', 'WI', 'WV',
    'YK'
];

const locationOptions = locations.map(loc => ({ value: loc, label: loc }));

const LocationSelect = ({ value, onChange }) => {
    const handleChange = useCallback((selected) => {
        if (selected) {
            onChange({ target: { value: selected.value } });
        }
    }, [onChange]);

    const selectedOption = useMemo(() => {
        return locationOptions.find(opt => opt.value === value) || null;
    }, [value]);

    return (
        <div style={{ marginBottom: '1rem' }}>
            <label className="block mb-1 text-sm font-bold">Location</label>
            <Select
                options={locationOptions}
                value={selectedOption}
                onChange={handleChange}
                placeholder="Select a location"
                isSearchable
                key="location-select"
            />
        </div>
    );
};

export default LocationSelect;